import {buildTheme} from '@sanity/ui/theme'
export const theme = buildTheme()
